import React, { memo, useMemo } from 'react';
import { Tag } from 'antd';
import { AWStageMemberDecisionDto } from '@api/Api';
import {
  AwstatusesApprovedIcon,
  AwstatusesOverdueIcon,
  AwstatusesPendingIcon,
  AwstatusesRequireChangesIcon
} from '@icons';

export type MemberDecisionProps = {
  decision?: AWStageMemberDecisionDto['decision'] | 'view' | 'overdue';
};

export default memo(function MemberDecision({
  decision = null
}: MemberDecisionProps) {
  const { color, text, icon } = useMemo(() => {
    if (decision === 'approved')
      return {
        color: '#58C97A33',
        text: 'Approved',
        icon: <AwstatusesApprovedIcon style={{ color: '#58C97A' }} />
      };
    if (decision === 'approved_with_feedback')
      return {
        color: '#496AFC1A',
        text: 'Approved with feedback',
        icon: <AwstatusesApprovedIcon style={{ color: '#496AFC' }} />
      };
    if (decision === 'changes_required')
      return {
        color: '#FA8E5233',
        text: 'Changes required',
        icon: <AwstatusesRequireChangesIcon style={{ color: '#FA8E52' }} />
      };
    if (decision === 'overdue')
      return {
        color: '#F7524833',
        text: 'Overdue',
        icon: <AwstatusesOverdueIcon style={{ color: '#F75248' }} />
      };
    if (decision === 'view')
      return {
        color: '#B0DAF8',
        text: 'In review',
        icon: <AwstatusesPendingIcon style={{ color: '#B0DAF8' }} />
      };
    return {
      color: '#F5DAE8',
      text: 'Waiting for review',
      icon: <AwstatusesPendingIcon style={{ color: '#F5DAE8' }} />
    };
  }, [decision]);

  return (
    <span className="status_container">
      <Tag color={color}>
        {icon}
        <div className="status_container--text">{text}</div>
      </Tag>
    </span>
  );
});
